import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PageLayout from '../../components/Layout/PageLayout';
import UserManagement from '../../components/UserManagement/UserManagement';
import { useRole } from '../../hooks/useRole';
import RoleGuard  from '../../components/RoleGuard';

const UserManagementPage: React.FC = () => {
  const { canViewData } = useRole();

  return (
    <PageLayout title="用戶管理">
      <Container maxWidth="xl">
        <Box sx={{ mb: 3 }}>
          <Typography variant="h4" gutterBottom>
            用戶管理系統
          </Typography>
          <Typography variant="body1" color="text.secondary">
            管理系統用戶帳戶、角色和權限
          </Typography>
        </Box>

        <RoleGuard
          requiredPermission="user.view"
          fallback={
            <Box sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" color="text.secondary">
                您沒有權限訪問用戶管理功能
              </Typography>
            </Box>
          }
        >
          <UserManagement />
        </RoleGuard>
      </Container>
    </PageLayout>
  );
};

export default UserManagementPage;
